<template>
  <div
    class="FaqClientPage pc"
    :class="{ chrome: isChrome(), focus: $store.state.tagSearch.show }"
    ref="faqClientTag"
    id="sai-faq-client"
  >
    <div class="content">
      <div class="search" ref="searchTop">
        <div class="title">
          <div class="text">
            {{ searchInputTitle }}
          </div>
        </div>
        <div ref="taggedInput" class="tagInput" id="sai-tag-search-input">
          <TaggedInput
            :selectedTags="selectedTags.values()"
            :searchText="searchText"
            :inputEmpty="inputEmpty"
            :filteredItems="filteredItems"
            @onTagRemoved="removeSelectedTag"
            @onSearchTextChanged="setSearchText"
            @setShow="setTagSearchShow"
          />
        </div>
        <div ref="tagList">
          <TagList
            :candidateTags="candidateTags"
            :tagListTop="tagListTop"
            :inputEmpty="inputEmpty"
            :searchText="searchText"
            @onSelectTag="addSelectedTag"
            @setShow="setTagSearchShow"
          />
        </div>
      </div>
      <div
        class="recommend"
        v-show="$store.state.tagSearch.show"
      >
        <div
          class="autocomplete"
          ref="autocomplete"
          :style="{ maxHeight: recommendMaxHeight }"
        >
          <Autocomplete
            v-show="!inputEmpty"
            :filteredItems="filteredItems"
            :inputEmpty="inputEmpty"
            @selected="selectItem"
            @setTagSearchShow="setTagSearchShow"
          />
          <Frequent
            v-show="inputEmpty"
            @setTagSearchShow="setTagSearchShow"
          />
        </div>
        <div class="close">
          <a class="button" @click.prevent="closeList">
            <span class="icon">
              <img src="../resource/sai-icon_close_light_gray.svg" />
            </span>
            <span class="text">閉じる</span>
          </a>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div
        class="sai-tag-search-modal"
        ref="modal"
        v-show="$store.state.tagSearch.show"
      ></div>
    </transition>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import FaqClientTagMixin from '@/mixins/FaqClientTagMixin';
import { eventBus } from '@/eventBus';
import Const from '../const/index';
import { Watch } from 'vue-property-decorator';

@Component({})
export default class FaqClientPage extends mixins(FaqClientTagMixin) {
  searchInputTitle = Const.SEARCH_INPUT_TITLE;

  scrollContainer = 'body';
  scrollTopElement = '#sai-faq-client';
  scrollSearchElement = '#sai_faqArea';
  scrollFaqElement = '#sai-faq-top';
  scrollAnswerElement = '#sai-scenario-answer';

  isIE = false;

  recommendHeight = 330;
  resultsHeight = 0;

  get recommendMaxHeight() {
    return `${this.recommendHeight + this.resultsHeight}px`;
  }

  // TODO: ブラウザ判定ライブラリ等を導入する
  isChrome() {
    return (
      !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
    );
  }
  handleTagList(e) {
    if (this.$refs.modal && this.$refs.modal.contains(e.target)) {
      this.setTagSearchShow(false);
    }
  }
  async tagifyTextExact(tagText) {
    await this.$store.dispatch('tagSearch/tagifyTextExact', tagText);
  }
  closeList() {
    if (this.$store.state.user.isIphone && this.$store.state.onIME) {
      eventBus.$emit('toggleIme', false);
      return;
    }
    this.setTagSearchShow(false);
  }
  updateRecommendHeight() {
    const results = document.getElementsByClassName('sai-faq-result');
    let height = 0;
    for (let i = 0; i < results.length; i++) {
      height += results[i].clientHeight;
    }
    this.resultsHeight = height;
  }
  @Watch('$store.state.tagSearch.filteredItems')
  onChangeFilteredItems() {
    if (this.inputEmpty) {
      this.resultsHeight = 0;
      return;
    }
    setTimeout(() => {
      this.updateRecommendHeight();
    }, 0);
  }
  created() {
    const ua = window.navigator.userAgent.toLowerCase();
    this.isIE = ua.indexOf('msie') != -1 || ua.indexOf('trident') != -1;
    eventBus.$on('updateRecommendHeight', () => {
      this.updateRecommendHeight();
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../style/setting/variable';

.FaqClientPage {
  .saiAnswerPage & {
    background-color: #eee;
    padding: 16px 16px 0 16px;
  }
}

.content {
  width: 100%;
  background-color: #eee;
  position: relative;
  z-index: 1;
  .focus & {
    z-index: 10000001;
  }

  .search {
    position: relative;
    padding: 12px 16px 6px 16px;

    .title {
      padding-bottom: 11px;
      .text {
        font-size: 18px;
        font-family: $subFontFamily;
        font-weight: 700;
        text-align: center;
      }
    }

    .tagInput {
      border-radius: 6px 6px 0 0;
    }
  }

  .recommend {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    position: absolute;

    > div {
      overflow-y: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .autocomplete {
      background-color: #fff;
    }

    .close {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;

      &.initial {
        background-color: #eee;
        @media screen and (min-width: 767px) {
          display: none;
        }
      }

      .button {
        padding: 4px 16px !important;
        background-color: #eee !important;
        border-radius: 16px !important;
        border: none !important;

        .icon {
          display: inline-block;
          position: relative;
          top: 2px;
          width: 16px;
          height: 16px;
          background-color: #757575;
          border-radius: 50%;
          img {
            position: relative;
            top: -1px;
            left: 2px;
            width: 12px;
            height: 12px;
            opacity: 1;
          }
        }
        .text {
          color: #757575;
          font-size: 13px;
          margin-left: 2px;
        }
      }
    }

    .category {
      padding: 0 0 0 16px;
      background-color: #eee;
      -ms-overflow-style: none; /* IE, Edge */
      scrollbar-width: none; /* Firefox */
    }
    .category::-webkit-scrollbar { /* Chrome, Safari */
      display: none;
    }
  }
}

.sai-tag-search-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: auto;
  width: 100%;
  overflow: hidden;
  background: rgba(44, 42, 41, 0.5);
  z-index: 10000000;

  /*
    埋め込み先の親が transform を使っているので一定以上の幅で absolute が効かない、
    以下を使って画面いっぱいに配置する
  */
  @media screen and (min-width: 1206px) {
    left: calc(50% - 50vw);
    right: calc(50% - 50vw);

    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// products/390/components/FaqClientPage.vue